module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/flow_arrow_mail-706bcb0a55d129c53b993e143e2a639b.svg";